export default __webpack_public_path__ + "static/media/select_profile_picture.bbd4568f.png";